import React from 'react';
import { XAiProviderProps } from '@/types/XAiProvider';
import XAiProvider from '@/components/XAiProvider';
import XAiChatbot from '@/components/XAiChatbot';

export interface XAiSDKProps extends XAiProviderProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  style?: React.CSSProperties;
}

const XAiSDK: React.FC<XAiSDKProps> = ({
  width = '400px',
  height = '600px',
  className,
  style,
  ...providerProps
}) => {
  const containerStyle: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    ...style,
  };

  return (
    <div className={className} style={containerStyle}>
      <XAiProvider {...providerProps}>
        <XAiChatbot />
      </XAiProvider>
    </div>
  );
};

export default XAiSDK;
